import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import Title from '../../components/Title';
import AuthContext from '../../contexts/AuthContext';
import '../../index.css';
import { getUserDetail, updateUser } from '../../modules/NetworkFunction';
import useYoutubeAccount from '../../hooks/useYoutubeAccount';
import AppStatusTable from '../../components/AppStatusTable';
import GuideModal from '../../components/GuideModal';
import styled from 'styled-components';

function MyPageSetting() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState();

  const location = useLocation();
  const { auth: token } = useContext(AuthContext);

  const { getChannelId, googleLogin } = useYoutubeAccount();
  const [isHovered, setIsHovered] = useState(false);
  const [youtubeAuthCode, setYoutubeAuthCode] = useState(
    location.search.includes('youtube') &&
      new URLSearchParams(location.search).get('code')
  );

  useEffect(() => {
    if (!isLoaded) {
      getUserDetail(
        null,
        (v) => {
          setData(v.user);
        },
        setIsLoaded,
        (e) => {
          console.log('getuserdetail', e);
        },
        token
      );
    }
  }, [isLoaded, token]);

  useEffect(() => {
    // 유튜브 계정 연결(redirect 된 후 code 있을 때 실행)
    if (youtubeAuthCode) {
      getChannelId(youtubeAuthCode, (id) => {
        updateUser(
          { youtubeAccount: id },
          () => {},
          () => {
            alert('계정 연결 완료');
            setYoutubeAuthCode(null);
          },
          (error) => {
            console.log(error);
          },
          token
        );
      });
    }
  }, [youtubeAuthCode, token, getChannelId]);

  const Fetch = () => {
    if (!youtubeAuthCode) {
      googleLogin();
    }
  };

  const onKeyChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <Title title="기본 설정" />
      <div
        style={{ display: 'flex', flexDirection: 'row', marginTop: 32 }}
        className="inner-box"
      >
        <div style={{ width: 600 }}>
          <div
            style={{ flex: 1, alignItems: 'center' }}
            className="checkbox-list"
          >
            <img
              src={'/icons/ic-check.png'}
              alt="check"
              style={{ width: 20, height: 12 }}
            />
            <label>
              <span
                style={{
                  marginLeft: 15,
                  fontSize: 18,
                }}
              >
                설치는 크롬 브라우저를 이용해주세요.
              </span>
            </label>
          </div>
          <div
            style={{ flex: 1, alignItems: 'center' }}
            className="checkbox-list"
          >
            <img
              src={'/icons/ic-check.png'}
              alt="check"
              style={{ width: 20, height: 12 }}
            />
            <label>
              <span
                style={{
                  marginLeft: 15,
                  fontSize: 18,
                }}
              >
                영상 업로드 옵션은 ‘유튜브 계정 연결하기’를 권장합니다.
              </span>
            </label>
          </div>
          <div
            style={{ flex: 1, alignItems: 'center' }}
            className="checkbox-list"
          >
            <img
              src={'/icons/ic-check.png'}
              alt="check"
              style={{ width: 20, height: 12 }}
            />
            <label>
              <span
                style={{
                  marginLeft: 15,
                  fontSize: 18,
                }}
              >
                <span
                  style={{
                    color: '#FF7A00',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    window.open(
                      'https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/Wizmon_usage_manual.pdf',
                      '_blank'
                    );
                  }}
                >
                  사용 가이드
                </span>
                를 통해 앱 서비스의 설정방법 및 상세한 기능을 알아보세요.
              </span>
            </label>
          </div>
        </div>
        <div
          style={{
            marginLeft: 50,
            justifySelf: 'flex-end',
            alignSelf: 'flex-end',
          }}
        ></div>
      </div>
      <AppStatusTable token={token} />
      <div style={{ marginTop: 40 }} className="inner-box">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 15,
          }}
        >
          <p style={{ fontSize: 22, marginRight: 463 }}>영상 업로드 옵션</p>
        </div>
        <div className="checkbox-list">
          <input type="checkbox" defaultChecked="true" disabled={true} />
          <label>
            <span>유튜브 계정 연결하기</span>
          </label>
          <a>
            <p
              style={{
                textDecoration: 'underline',
                color: '#FF7A00',
                marginLeft: 200,
                cursor: 'pointer',
              }}
              onClick={Fetch}
            >
              계정 연결 바로가기
            </p>
          </a>
        </div>
        <div
          style={{ display: 'flex', marginBottom: 5.5 }}
          className="checkbox-list"
        >
          <input type="checkbox" defaultChecked="true" disabled={true} />
          <label>
            <span>유튜브 API Key</span>
          </label>
          <a
            href="https://developers.google.com/youtube/v3/getting-started"
            target="_blank"
            rel="noreferrer"
            style={{
              color: '#FF7A00',
              textDecoration: 'underline',
              cursor: 'pointer',
              marginLeft: 200,
              fontSize: 18,
            }}
          >
            유튜브 API Key 생성
          </a>
          <div
            style={{
              marginLeft: '50px',
              marginTop: '5px',
              display: 'flex',
              cursor: 'pointer',
              position: 'relative',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <img src="/icons/ic-question-mark.png" alt="help" />
            <p
              style={{
                color: '#FF7A00',
                cursor: 'pointer',
                fontSize: 14,
                marginLeft: 8,
                textDecoration: isHovered ? 'underline' : 'none',
                lineHeight: isHovered ? 'normal' : 'initial',
              }}
            >
              도움이 필요하신가요?
            </p>
            {isHovered && (
              <GuideModal
                videoLink="https://youtu.be/SgAQ5j1rSa8?si=qk1Ne3GtcZ0vRyRQ"
                pdfLink="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/guides/wizmon_youtubeAPI_guide_220729.pdf"
                style={{ marginLeft: '40px' }}
              />
            )}
          </div>
        </div>
        <div className="input-box" style={{ marginTop: 0 }}>
          <input
            type="text"
            name="youtubeAPIKey"
            placeholder="유튜브 API Key를 입력해주세요."
            defaultValue={data ? data.youtubeAPIKey : undefined}
            onChange={onKeyChange}
            style={{ width: 627, height: 38 }}
          />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
        }}
      >
        <ButtonContainer>
          <RoundButton
            onClick={() => {
              let userData = {
                youtubeAPIKey: data.youtubeAPIKey,
              };
              updateUser(
                userData,
                () => {},
                () => {
                  alert('회원정보가 변경되었습니다.');
                },
                (error) => {
                  console.log(error);
                },
                token
              );
            }}
          >
            저장
          </RoundButton>
        </ButtonContainer>
      </div>
    </div>
  );
}

export default MyPageSetting;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 30px 0 30px 0;
`;

const RoundButton = styled.div`
  display: flex;
  height: 40px;
  width: 100px;
  padding: 6px 6px;
  text-align: center;
  border-radius: 20px;
  font-size: 20px;
  border-width: 0;
  background-color: #ffb600;
  color: #fff;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
`;
